import {
  CodeIcon,
  LockIcon,
  Shield01Icon,
  UserGroupIcon,
  UserIcon
} from '@hugeicons/react'

import { useNetworkingAvailability } from '@/features/networking'
import { useDebugPanelEligible } from '@/shared/lib/debug-panel/useDebugPanelEligible'

import { ACCOUNT_PATHS } from './config'

/**
 * Seções visíveis na faixa de navegação de "Minha conta".
 *
 * Duas seções são condicionais e cada uma tem um motivo diferente:
 *
 * - **Networking** depende do evento ter o recurso configurado. Enquanto a
 *   declaração está em voo a entrada fica de fora — renderizar e depois remover
 *   faria a faixa piscar e deslocaria as entradas vizinhas sob o dedo de quem
 *   já estava mirando uma delas.
 * - **Desenvolvimento** é ferramental de staff. Para quem não é elegível ela não
 *   existe: nada de entrada desabilitada nem espaço reservado.
 */
export const useAccountSections = () => {
  const networking = useNetworkingAvailability()
  const isStaff = useDebugPanelEligible()

  return [
    {
      to: ACCOUNT_PATHS.profile,
      label: 'Perfil',
      icon: <UserIcon variant="stroke" />
    },
    ...(!networking.isLoading && networking.isAvailable
      ? [
          {
            to: ACCOUNT_PATHS.networking,
            label: 'Networking',
            icon: <UserGroupIcon variant="stroke" />
          }
        ]
      : []),
    {
      to: ACCOUNT_PATHS.security,
      label: 'Segurança',
      icon: <LockIcon variant="stroke" />
    },
    {
      to: ACCOUNT_PATHS.privacy,
      label: 'Privacidade',
      icon: <Shield01Icon variant="stroke" />
    },
    ...(isStaff
      ? [
          {
            to: ACCOUNT_PATHS.development,
            label: 'Desenvolvimento',
            icon: <CodeIcon variant="stroke" />
          }
        ]
      : [])
  ]
}
